module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/188-peru-f731009a1a6a2cf0797df5be515152b4.svg";